import { useQuery } from '@tanstack/react-query';

import { fetchSpotBidExpirationTimeOptions } from '../../data-provider/spot-bid-expiration';
import type { GetSpotBidExpirationTimeRequestParams } from '../../data-provider/spot-bid-expiration/api';

export const useGetSpotBidExpirationTimeOptions = (params: GetSpotBidExpirationTimeRequestParams) => {
  return useQuery({
    enabled: Boolean(params.CustomerKey),
    queryFn: () => fetchSpotBidExpirationTimeOptions(params as GetSpotBidExpirationTimeRequestParams),
    queryKey: ['shipment-spot-bid-expiration-time-options', params],
    // biome-ignore lint/style/noMagicNumbers: 1 hour
    staleTime: 1000 * 60 * 60,
  });
};
